module.exports = __webpack_public_path__ + "img/DE06237.e2eb6f2d.png";